// extracted by mini-css-extract-plugin
export default {"fragment_place_holder":"fsp-fragment_place_holder","invisible_container":"fsp-invisible_container"};